import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NewsArticleErrorLog, NewsArticleErrorLogQueryParams } from 'src/models';

@Injectable({ providedIn: 'root' })
export class NewsArticleLogsService {
  private readonly url = `${environment.bffUrl}/news-logs`;
  constructor(private httpClient: HttpClient) {}

  getAll(params: NewsArticleErrorLogQueryParams): Observable<NewsArticleErrorLog[]> {
    return this.httpClient.get<NewsArticleErrorLog[]>(this.url, { params });
  }
}
